import lookups from "./lookups";
import { AccountFormStages } from "./account";
import { administratorRoles } from "../js/roles";

export const AccountsFormStages = [
  {
    title: "Accounts",
    sections: [
      {
        name: "",
        table: {
          allowAdd: true,
          allowAddRoles: administratorRoles,
          allowEdit: true,
          allowStatusEdit: true,
          statusEditAllowedRoles: administratorRoles,
          useSubmitButton: true,
          fields: [
            {
              name: "createdon",
              className: "col-date",
              type: "datetime",
            },
            {
              name: "modifiedon",
              className: "col-date",
              type: "datetime",
            },
          ],
          filterByStatus: true,
          filters: [
            {
              name: "name",
              type: "text",
            },
          ],
          linkForNewRecord: "/account",
          subFormStages: AccountFormStages,
          lookup: lookups.account.all,
          useAlphabetPagination: false,
          useSubForm: false,
        },
      },
    ],
  },
];
